/* istanbul ignore file */

export { FaqAccordion as default } from "./FaqAccordion";

